import {
  getNativeFlag,
  getNativeFunction,
  NativeFunctions,
  NativeFlags,
} from '@/components/shared/nativeApp';

const nativeAppBanner = document.querySelector('header.solv-native-app-header');
const isInNativeApp = nativeAppBanner !== null;
if (isInNativeApp) {
  const backButton = nativeAppBanner.querySelector('[data-back-button]');
  backButton.addEventListener('click', () => {
    window.history.back();
  });

  const allPageLinks = document.querySelectorAll('a');
  allPageLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      if (link.dataset.inAppLink === 'true') {
        if (
          !link.href.includes('?') &&
          !link.href.includes('#') &&
          !link.href.includes('r/home')
        ) {
          link.href = link.href + `?isNativeApp=true`;
        }
        return;
      } else {
        // open this link in an external browser
        e.preventDefault();
        NativeFunctions.openNativeUrl.call(link.href);
      }
    });
  });
}
